export default {
    homepageLink: "Home Page",
    cashbackLink: "Cashback",
    offersLink: "Occasions",
    eKarty: "eCards",
    flyersLink: "Flyers",
    blogLink: "",
    pluginLink: "Plugin",
    pluginMsg: "New",
    mgmLink: "Recommend and earn",
    shoppingCenterLink: "Shopping Malls",
    favoritesLink: "Favourites",
};
